import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY as crumbLabel } from '../constants';
import { apiProvider } from '../api';

const edit = {
	ExportId: null as number | null,
	ExportName: null as string | null,
	ExportFixlength: null as number | null,
	ExportSuffix: null as string | null,
	ExportFilename: null as string | null,
	ExportDefaultType: null as number | null,
	ExportFlag: null as number | null,
	ExportDefaultDelim: null as string | null,
	ExportSelect: null as string | null,
	Export_HeaderRow: null as boolean | null,
	Export_OverWriteExtension: null as boolean | null,
	Export_DefaultQuota: null as string | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel,
	dropdownList: {
		ExportDefaultType: [],
	},
	depTableSettings: {},
	depTableNames: [],
	edit,
	localState: {},
	extraGetters: {},
	extraMutations: {},
	extraActions: {},
	props: {
		filter: {},
		mode: null,
	},
});
